// removed by extract-text-webpack-plugin
module.exports = {"root":"sliderMobileSection__root--1gPqd","reversed":"sliderMobileSection__reversed--36ytL","slider":"sliderMobileSection__slider--bws_P","cardStack":"sliderMobileSection__cardStack--b1ZpM","phoneIcon":"sliderMobileSection__phoneIcon--znuiR","phoneIconDesktop":"sliderMobileSection__phoneIconDesktop--HXiNQ","sliderCard":"sliderMobileSection__sliderCard--3GPe2","sliderImg":"sliderMobileSection__sliderImg--1YVm_","textWrapper":"sliderMobileSection__textWrapper--39wv5","textContainer":"sliderMobileSection__textContainer--1NRcK","dots":"sliderMobileSection__dots--WVIAe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SliderMobileSection/sliderMobileSection.css
// module id = rAB2
// module chunks = 0